import moment from 'moment';

export const formatDateWithRemaining = (dateString, t, options = {}) => {
  if (!dateString) return '';

  const {
    dateFormat = 'DD.MM.YYYY, HH:mm',
    includeRemaining = true,
    nowMs = null
  } = options;

  const targetDate = moment(dateString);
  const formattedDate = targetDate.format(dateFormat);

  if (!includeRemaining || nowMs == null) {
    return formattedDate;
  }

  const now = moment(nowMs);
  const duration = moment.duration(targetDate.diff(now));

  const days = Math.floor(duration.asDays());
  const hours = Math.floor(duration.asHours() % 24);

  let remainingTime = '';

  if (days > 0) {
    remainingTime = `${days} ${getDayWord(days, t)}`;
  }

  if (hours > 0 || days > 0) {
    if (remainingTime) remainingTime += ' ';
    if (hours > 0) {
      remainingTime += `${hours} ${getHourWord(hours, t)}`;
    }
  }

  if (remainingTime) {
    return `${formattedDate} (${t('common.datetime.remainingPrefix')} ${remainingTime})`;
  } else if (duration.asMilliseconds() < 0) {
    return `${formattedDate} (${t('common.datetime.expiredText')})`;
  } else {
    return `${formattedDate} (${t('common.datetime.remainingPrefix')} ${t('common.datetime.lessThanHourText')})`;
  }
};

function getDayWord(count, t) {
  if (count === 1) return t('common.datetime.daysOne');
  if (count >= 2 && count <= 4) return t('common.datetime.daysFew');
  return t('common.datetime.daysMany');
}

function getHourWord(count, t) {
  if (count === 1) return t('common.datetime.hoursOne');
  if (count >= 2 && count <= 4) return t('common.datetime.hoursFew');
  return t('common.datetime.hoursMany');
}
